import React, { useEffect, useState, useMemo } from 'react';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { useLocation, useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system';
import { Rating, Button, TextField } from '@mui/material';
import { Check, PublishedWithChanges, Send } from '@mui/icons-material';
import { toast } from 'react-toastify';
import postReq from '../interface/postRequestinterface'
import { postRequest } from '../request';
import { useMediaQuery } from "react-responsive"; 


const style={
    formTitle:{
      fontWeight:'bold !important'
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      backgroundColor: '#f1f7ff59',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem'
    },
    container:{
      display:'flex',
      alignItems:'center',
      flexDirection:'column',
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'40% 40%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'30rem'
    },
    modalMobileStyle:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'15rem'
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'space-between'
    },
    stateType:{
      fontWeight:'bold'
    },
    title:{
      display:'flex',
      justifyContent:'space-between',
      width:'65rem',
    },
    unShown:{
      visibility:'none'
    }
  }
  interface QuestionType{
    questionId:number;
    choice:number
  }

function ClientPoll() {
    const location = useLocation();    
    const zeroArray = new Array(location.state.length).fill(location.state.questions.map(x=>({choice:0,questionId:x.questionId})));
    const [description, setDescription] = useState<string>('');
    const [rate, setRate] = useState<Array<QuestionType>>(zeroArray[0]);
    const [allowReAnswer, setAllowReAnswer] = useState<number>(-1);
    const [doneQuestion, setDoneQuestion] = useState(0);
    const navigate = useNavigate();
    const isDesktop = useMediaQuery({
      query: "(min-width: 1224px)"
    });
    
    const isTablet = useMediaQuery({
      query: "(max-width: 650px)"
    });
    
    const isMobile = useMediaQuery({
      query: "(max-width: 400px)"
    });

    const cacheRtl = useMemo(() => {
      return createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin]
      });
    }, []);
    
    const handleClickSendRate=(idx)=>{
      if(idx>=doneQuestion){
        setDoneQuestion(prevState=>prevState+1);
      }else{
        setAllowReAnswer(-1);
      }
    }
    const handleSendPoll= async ()=>{ 
      const tempData:any = {
        comment:description,
        pollFormId:location.state.pollformId,
        answers:rate
      }
      const {message,error} :postReq = await postRequest(`${process.env.REACT_APP_BASE_URL}/Poll/SubmitPollForm`,tempData) as postReq;
      if(message === 'ok'){
        toast.success('پاسخ شما با موفقیت ثبت شد!');
        navigate('/listOfQuestions');
      }else{
        toast.error(error);
      }
    }
  return (
    <CacheProvider value={cacheRtl}>
        <div className='background'>
          <Box sx={style.container}>
            <Box sx={isDesktop?
                    {height:'4rem',display:'flex',alignItems:'center',width:'80%'}:
                    isMobile?
                    {height:'4rem',display:'flex',alignItems:'center',width:'80%',marginBottom:'3rem',marginTop:'2.5rem'}:
                    {height:'4rem',display:'flex',alignItems:'center',width:'80%'}
                  }
              >
              <Typography variant={isDesktop? 'h5':'h6'} sx={{fontWeight:'bold',textAlign:'justify'}}>
                با تشکر از تخصیص زمان برای پاسخ به نظر سنجی لطفا با دقت به سوالات مطرح شده پاسخ دهید
              </Typography>
            </Box>
            {
              location.state.questions.map((q,idx)=>
                <Box key={idx} sx={style.formContainer} className={doneQuestion===idx?'fade':idx>=doneQuestion?'unShown':''}>
                    <Typography variant={isDesktop? 'h5':'body1'} sx={{textAlign:'justify'}}>{q.questionString}</Typography>
                    <Box
                      sx={isDesktop?{
                        height:'4rem',
                        display:'flex'
                      }:{
                        height:'2rem',
                        display:'flex'
                      }}>
                        <Typography gutterBottom>امتیاز شما:</Typography>
                        <Rating
                          value={rate[idx].choice}
                          disabled={doneQuestion>idx?idx===allowReAnswer?false:true:false}
                          onChange={(event, newValue) => {
                              setRate(prevState=>{
                                return prevState.map((x,index)=>{
                                  if(index === idx){
                                    return {choice:newValue!,questionId:x[index]?x[index].questionId!:x.questionId!};
                                  }else{
                                    return {choice:x[index]?x[index].choice!:x.choice!,questionId:x[index]?x[index].questionId!:x.questionId};
                                  }
                                })
                              });
                          }}
                        />
                        <Typography sx={{fontWeight:'bold',marginLeft:'1rem'}}>{rate[idx].choice}</Typography>
                    </Box>
                    <Box>
                      {
                        doneQuestion>idx?idx===allowReAnswer?
                        <Button variant="contained" color="primary" onClick={()=>handleClickSendRate(idx)}>
                          ثبت نظر<Check/>
                        </Button>:
                        <Box>
                          <Button variant="contained" color="secondary" onClick={()=>setAllowReAnswer(idx)}>
                            تجدید نظر<PublishedWithChanges/>
                          </Button>
                          <Typography variant={isDesktop? 'body1':'body2'} color="initial">نظر شما با موفقیت ثبت شد</Typography>
                        </Box>:
                        <Button variant="contained" color="primary" onClick={()=>handleClickSendRate(idx)}>
                          ثبت نظر<Check/>
                        </Button>
                      }
                    </Box>
                </Box>
                )
            }
          </Box>
          {doneQuestion>=location.state.questions.length?
          <Box sx={{width:'100%',display:'flex',justifyContent:'center'}}>
            <Box 
                sx={isMobile?
                  {width:'80%',display:'felx',flexDirection:'column',marginBottom:'2rem'}:
                  {width:'80%',display:'felx',flexDirection:'column'}
                }
            >
              <TextField
              label='توضیحات' 
              multiline
              rows={3}
              value={description}
              onChange={(e)=>setDescription(e.target.value)}
              sx={{marginBottom:'1rem',width:'100%'}}
              />
              <Button variant="contained" color="primary" sx={{marginBottom:'1rem'}} onClick={handleSendPoll}>
                ثبت نهایی<Send/>
              </Button>
            </Box>
          </Box>
          :null
          }
        </div>
    </CacheProvider>
  )
}

export default ClientPoll
